import { render } from "./WorkspacePage.vue?vue&type=template&id=d846d47c"
import script from "./WorkspacePage.vue?vue&type=script&lang=js"
export * from "./WorkspacePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__